import "./MetaDocAIProcessingScreen.scss";

import LoadingIcon from "components/Loading/LoadingIcon";

type MetaDocAIProcessingScreenProps = {
  onComplete: () => void;
  jobStatus?: string;
};

const MetaDocAIProcessingScreen = ({
  jobStatus,
}: MetaDocAIProcessingScreenProps) => {
  const isPending = jobStatus === "Pending";

  const displayMessage = {
    icon: isPending ? "schedule" : "hourglass_empty",
    text: isPending ? "Pending" : "In Progress",
  };

  return (
    <div className="metadoc-ai-processing">
      <div className="metadoc-ai-processing__content">
        <div className="metadoc-ai-processing__icon-container">
          <span className="material-icons metadoc-ai-processing__main-icon">
            auto_awesome
          </span>
        </div>

        <h2 className="metadoc-ai-processing__title">
          {isPending ? "AI Analysis Starting..." : "AI Analysis in Progress"}
        </h2>

        <div className="metadoc-ai-processing__message">
          <span className="material-icons metadoc-ai-processing__message-icon">
            {displayMessage.icon}
          </span>
          <span className="metadoc-ai-processing__message-text">
            {displayMessage.text}
          </span>
        </div>

        <LoadingIcon size="large" showText={false} />

        <p className="metadoc-ai-processing__subtitle">
          {isPending
            ? "Waiting for processing to begin..."
            : "Processing time varies based on document size..."}
        </p>
      </div>
    </div>
  );
};

export default MetaDocAIProcessingScreen;
